import React from 'react';
import { Box, Typography } from '@mui/material';
import MagazineSectionContainer from './MagazineSectionContainer';

/**
 * SectionTitle
 * @param {object} props
 * @param {string} [props.title] - 타이틀 텍스트
 * @param {React.ReactNode} [props.children] - 섹션 내부 컨텐츠
 * @param {'left'|'center'|'right'} [props.align='left'] - 정렬 방향
 * @param {boolean} [props.gutterBottom=true] - 하단 간격 여부
 * @param {object} [props.sx] - 추가 스타일(MUI sx)
 * @param {boolean} [props.withContainer=true] - 컨테이너(보더/패딩) 포함 여부
 */
const SectionTitle = ({
  title,
  children,
  align = 'left',
  gutterBottom = true,
  sx,
  withContainer = true,
}) => {
  const titleNode = (
    <MagazineSectionContainer title={title} titleAlign={align} withContainer={withContainer} sx={sx}>
      {children}
    </MagazineSectionContainer>
  );

  return titleNode;
};

export default SectionTitle;


